import { useEffect, useState } from "react";

import { useGifQuery } from "@/common/queries/queries";
import { EmbeddedVideoPlayer } from "../EmbeddedVideoPlayer";
import { IGifInfo } from "@/common/services/types";

export const PlayerWrapper = (props: {
  id: string;
}): JSX.Element => {
  const [info, setInfo] = useState<IGifInfo|undefined>(undefined);

  const query = useGifQuery(props.id);

  useEffect(() => {
    if (query.isSuccess && query.data) {
      setInfo(query.data);
    }
  }, [query.isSuccess, query.data]);

  if (info) {
    return (
      <EmbeddedVideoPlayer
        gif={info.gif}
        id={info.gif.id}
        createDate={info.gif.createDate}
        userName={info.user?.username}
        userPic={info.user?.profileImageUrl}
        sdVideo={info.gif.urls.sd}
        hdVideo={info.gif.urls.hd}
        poster={info.gif.urls.thumbnail}
        sound={!!info.gif.hasAudio}
        verified={!!info.user?.verified}
        isStudio={!!info.user?.studio}
      />
    );
  } else if (query.isLoading) {
    return <div className="embedPage">
      <p className="message">Loading...</p>
    </div>;
  } else if (query.isError) {
    return <div className="embedPage">
      <p className="error message">Error loading this gif.</p>
    </div>;
  } else {
    return <></>;
  }
};
